if (typeof Object.get === 'undefined') {
    Object.get = function (mainObj, key, defaultvalue = null) {
        let recursive = function (obj, keys) {
            if (obj === null || typeof obj === 'undefined' || Object.keys(obj).length === 0 || keys.length === 0 || keys[0] in obj === false) {
                if (defaultvalue !== null) {
                    return defaultvalue;
                }
                return null;
            }
            if (keys.length === 1) {return obj[keys[0]];}
            if (keys[0] in obj) {
                return recursive(obj[keys[0]], keys.splice(1));
            }
        };
        return recursive(mainObj, key.split('.'));
    }
} else {
    console.warning("Object.get is already used");
}

if (typeof Object.reset === 'undefined') {
    Object.reset = function (obj) {
        for (let key in obj) {
            if (obj.hasOwnProperty(key)) {
                if (typeof obj[key] === 'object' && obj[key] !== null) {
                    Object.reset(obj[key]);
                } else if (typeof obj[key] === 'function') {
                    obj[key] = obj[key];
                } else {
                    obj[key] = null;
                }
            }
        }
    }
} else {
    console.warning("Object.reset is already used");
}

if (typeof Array.prototype.contains === 'undefined') {
    Object.defineProperty(Array.prototype, 'contains', {
        enumerable: false,
        value: function value(needle) {
            return this.filter(function (item) {
                return JSON.stringify(item) === JSON.stringify(needle);
            }).length > 0;
        }
    });
} else {
    console.warning("Array.prototype.contains is already used");
}

if (typeof Array.prototype.lists === 'undefined') {
    Object.defineProperty(Array.prototype, 'lists', {
        enumerable: false,
        value: function value(identifier) {
            return this.map(m => Object.get(m, identifier));
        }
    })
} else {
    console.warning("Array.prototype.lists is already used");
}

if (typeof String.prototype.capitalize === 'undefined') {
    String.prototype.capitalize = function() {
        return this.split(' ').map(s => s.charAt(0).toUpperCase() + s.slice(1) ).join(' ')
    }
} else {
    console.warning("String.prototype.capitalize is already used");
}

if (typeof window.crsf === 'undefined') {
    window.crsf = function() {
        let metaToken = document.querySelector('[name=csrf-token]');
        if (metaToken) {
            return metaToken.getAttribute('content')
        }
    }
} else {
    console.warning("window.crsf is already used");
}

if (typeof window.swell === 'undefined') {
    window.swell = {
        crsf: function() {
            let metaToken = document.querySelector('[name=csrf-token]');
            if (metaToken) {
                return metaToken.getAttribute('content')
            }
        },
        getAppUserId() {
            let meta = document.querySelector('[name=app_user_id]');
            if (meta) {
                return meta.getAttribute('content')
            }
            return null;
        },
        spinner: {
            start: function() {

            },
            end: function() {

            }
        },
        isArray(a) {
            return (!!a) && (a.constructor === Array);
        },
        isObject(a) {
            return (!!a) && (a.constructor === Object);
        },
        debounce(fn, delay) {
            var timeoutID = null;
            return function () {
                clearTimeout(timeoutID);
                var args = arguments;
                var that = this;
                timeoutID = setTimeout(function () {
                    fn.apply(that, args)
                }, parseInt(delay) || 500);
            }
        },
        scrollToFirstError() {
            window.setTimeout( () => {
                let invalidFeedback = document.querySelectorAll('.error--text');
                if (invalidFeedback.length) {
                    invalidFeedback[0].parentElement.scrollIntoView(true)
                }
            }, 500)
        },
        displayError(err, toastrText = 'Error processing request') {
            let validationErrors = Object.get(err.response, 'data.errors');

            if (validationErrors && Object.keys(validationErrors).length) {
                toastrText = Object.get(validationErrors, '0.detail', validationErrors[Object.keys(validationErrors)[0]][0]);
            } else {
                toastrText = Object.get(err.response, 'data.message', Object.get(err.response, 'data.text', toastrText));
            }

            window.toastr.error(toastrText);
            this.scrollToFirstError();
        },
        setGraphQLErrorValidationError(ValidationErrorHandler, errResponse) {
            ValidationErrorHandler.setMessageBag(Object.get(errResponse.graphQLErrors.find((e) => e.extensions.category === "validation"), 'extensions.validation', {}))
        },
        browserIsOldIE() {
           return navigator.userAgent.indexOf('MSIE')!==-1 || navigator.appVersion.indexOf('Trident/') > 0
        },

        labelfy(val){
            return val.replace(/\s+/g, '_').toLowerCase();
        },
        underScoreToSpaces(v) {
            return v.replace(/_/g, ' ');
        },
        setCookie(cname, cvalue, exdays = 30) {
            var d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            var expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname, defaultValue = null) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(';');
            for(var i = 0; i <ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return defaultValue;
        },
        getLocalStorage(cname, defaultValue = null) {
            let i = window.localStorage.getItem(cname);
            return i ? i : defaultValue
        },
        setLocalStorage(cname, value) {
            window.localStorage.setItem(cname, value)
        },
        toastr: {
            default(text, timeout) {
                if (timeout) {
                    window.app.snackbar_timeout = timeout;
                }
                window.app.snackbar_text = text;
                window.app.snackbar = true;
            },
            info(text, timeout = null) {
                window.app.snackbar_color = '';
                this.default(...arguments)
            },
            error(text, timeout = null) {
                window.app.snackbar_color = 'red';
                this.default(...arguments)
            }
        },
        roundByCasePack(qty, casePack) {
            return casePack * Math.ceil (qty / casePack)
        },
        getUrlParam(param) {
            let urlSearchParams = new URLSearchParams(window.location.search);
            return urlSearchParams.get(param);
        },
        uuidv4() {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        },
        formAppend(form, field, value, args = {}) {
            if (value != null) {
                if (Array.isArray(value)) {
                    value.forEach(v => form.append(`${field}[]`, v))
                } else {
                    form.append(field, value)
                }
            }
        }
    };
} else {
    console.warn("was not able to initialized the spinner. window.swell already taken.");
}

if (typeof Array.prototype.move === 'undefined') {
    Object.defineProperty(Array.prototype, 'move', {
        enumerable: false,
        value: function value(from, to) {
            this.splice(to, 0, this.splice(from, 1)[0]);
        }
    });
} else {
    console.warn("Array.prototype.move is already assigned");
}

if (typeof Object.keyBy === 'undefined') {
    Object.keyBy = function(obj, key) {
        var temp = {};
        if (Array.isArray(obj)) {
            obj.forEach(function (a) {
                temp[Object.get(a, key)] = a;
            });
        } else {
            Object.keys(obj).forEach(function (objkey) {
                temp[Object.get(obj[objkey], key)] = obj[objkey];
            });
        }
        return temp;
    }
} else {
    console.warn("Object.prototype.keyBy is already assigned");
}

if (typeof Object.toArray === 'undefined') {
    Object.toArray = function (obj) {
        return Object.keys(obj).map(o => obj[o])
    }
} else {
    console.warn("Object.toArray is already assigned");
}